/**
 * Where the API lives. Empty (the default) means same origin, which is how the
 * one-container deploy works. Set VITE_API_URL at build time when the frontend is
 * served from a different host (a CDN or a separate service), e.g.
 * https://boss-api.collectorcrypt.com, and set CORS_ORIGIN on the API to match.
 */
export const API_BASE = ((import.meta.env.VITE_API_URL as string | undefined) ?? '').replace(/\/+$/, '')

export const apiUrl = (path: string) => `${API_BASE}${path.startsWith('/') ? path : `/${path}`}`
